import { Outlet } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/hooks/useAuth";
import { useOrg } from "@/hooks/useOrg";
import { decideWorkshopsGate, WORKSHOPS_NOT_ENABLED_COPY } from "@/lib/workshopFeatureGate";

// WP15 (orgui-7): layout-route guard for /org/workshops and its detail page.
// Before this, the sidebar hid the Workshops entry when the flag was off but a
// typed URL still rendered the list and the wizard, which then failed only at
// the final Publish click with a server error. Renders INSIDE AppShell's main
// pane, so the blocks use in-page heights (h-64), never h-screen like
// AuthGuard. The decision itself lives in src/lib/workshopFeatureGate.ts.
export function WorkshopsFeatureGuard() {
  const { orgUser, realRole, isImpersonating } = useAuth();
  const { org, loading, error } = useOrg(orgUser?.orgId ?? undefined);
  const gate = decideWorkshopsGate({ orgLoading: loading, org, realRole, isImpersonating });

  if (gate === "loading") {
    return (
      <div className="flex h-64 items-center justify-center">
        <Loader2 className="h-6 w-6 animate-spin text-text-muted" />
      </div>
    );
  }
  if (error) {
    return (
      <div className="rounded-lg border border-border bg-card p-8 text-center">
        <p className="font-body text-sm text-text-muted">{error}</p>
      </div>
    );
  }
  if (gate === "not_enabled") {
    return (
      <div className="rounded-lg border border-dashed border-border bg-card p-8 text-center">
        <h1 className="mb-2 font-heading text-lg font-semibold text-text">Workshops</h1>
        <p className="font-body text-sm text-text-muted">{WORKSHOPS_NOT_ENABLED_COPY}</p>
      </div>
    );
  }
  return <Outlet />;
}
